var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalyticsExcluded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentBg"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.41421L3.41421 2L18.0018 16.5876L16.5876 18.0018L2 3.41421Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.75706L9 4.75706V2.00064H11V6.75706Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.75706L16 11.7571V6.00064H14V9.75706Z",
    fill: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.0006V13.2423L11 15.2423V18.0006H9Z",
    fill: "#909090"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.0006H4V18.0006H6V10.0006Z",
    fill: "#909090"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsExcluded);
export default __webpack_public_path__ + "static/media/AnalyticsExcluded.cc374eb8bcbacae5fbdb8e1b4e7ac75d.svg";
export { ForwardRef as ReactComponent };